import { Component, OnInit } from '@angular/core';
import { areeTematiche } from '../menu';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-homeprivata',
  templateUrl: './homeprivata.component.html',
  styleUrls: ['./homeprivata.component.css', '../../styles/main2.css']
})
export class HomeprivataComponent implements OnInit {
  mapCenter = [9.1, 40.1];
  basemapType = 'hybrid';
  mapZoomLevel = 7;
  areetematiche: any;
  username: string;

  constructor(user: AuthService) { 
    this.areetematiche = areeTematiche;
    this.username = user.getUsername();
    }

  getUsername(): string {
    return this.username;
  }

  ngOnInit() {
  }

  mapLoadedEvent(status: boolean) {
  }

  toggleSubSection(div2toggle) {
    div2toggle.hidden = !div2toggle.hidden;
  }
}
